/* Copyright (c) 2020-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { FlexContainer, Message, theme, Text } from "@nordcloud/gnui";

type MessageContent = {
  emptyMessage: string;
  createButton?: React.ReactNode;
};

type Props = {
  children: React.ReactNode;
  isEmpty: boolean;
  renderMessageContent: MessageContent;
};

export function List({ children, isEmpty, renderMessageContent }: Props) {
  return (
    <>
      {isEmpty ? (
        <Message status="notification" image="info">
          <FlexContainer direction="column" alignItems="start">
            <Text
              weight="medium"
              color={theme.color.text.info}
              mb={theme.spacing.spacing04}
            >
              {renderMessageContent.emptyMessage}
            </Text>
            <FlexContainer>{renderMessageContent.createButton}</FlexContainer>
          </FlexContainer>
        </Message>
      ) : (
        children
      )}
    </>
  );
}
